export default __webpack_public_path__ + "assets/images/3dfe8af01dd36671fa77f7ab9e847d67.svg";